module.exports = __webpack_public_path__ + "img/637229734730164567corona-website-1.png";